/**
 * Human labels for store pack contents — derived from authored catalogs, not hard-coded blurb lists.
 */
import {
  EMPTY_BOWL_HEADLINE_TEMPLATES,
  FOUND_PHONE_HEADLINE_TEMPLATES,
  SHARED_CAMERA_MOTIONS,
  SHARED_LOOK_TREATMENTS,
  SHARED_SFX_OPTIONS,
  SHARED_STICKER_OPTIONS,
  SHARED_TRANSITION_PRESETS,
} from "../../content/creative-catalogs.js";
import { PACK_REGISTRY, SHIFT_PACK_ORDER } from "../../content/registry.js";
import type { CreativeOptionKind } from "../../game/store-catalog.js";

// Every SHIPPED level's headlines (now authored in its level.json) plus the
// store-only headline packs, which belong to no level. Sourcing the level side
// from the registry means a new level's headlines get labels for free; this
// used to name Vet Day's set explicitly and silently missed the other two.
const HEADLINE_LABELS = new Map(
  [
    ...SHIFT_PACK_ORDER.flatMap((id) => PACK_REGISTRY[id]?.pack.headlineTemplates ?? []),
    ...EMPTY_BOWL_HEADLINE_TEMPLATES,
    ...FOUND_PHONE_HEADLINE_TEMPLATES,
  ].map((t) => [t.id, t.label] as const),
);

export function creativeOptionLabel(
  kind: CreativeOptionKind,
  id: string,
): string | null {
  switch (kind) {
    case "headline":
      return HEADLINE_LABELS.get(id) ?? null;
    case "sfx":
      return SHARED_SFX_OPTIONS.find((o) => o.id === id)?.label ?? null;
    case "look":
      return SHARED_LOOK_TREATMENTS.find((o) => o.id === id)?.label ?? null;
    case "motion":
      return SHARED_CAMERA_MOTIONS.find((o) => o.id === id)?.label ?? null;
    case "sticker":
      return SHARED_STICKER_OPTIONS.find((o) => o.id === id)?.label ?? null;
    case "transition":
      return SHARED_TRANSITION_PRESETS.find((o) => o.id === id)?.label ?? null;
    default:
      return null;
  }
}
